let variants = document.querySelectorAll('.js-pcard-variants');

variants.forEach(variant => {
  variant.addEventListener('mouseenter', function(event) {
    let targetEle = event.target;
    let prevEle = event.currentTarget.previousElementSibling;
    let prevEleMainImg = prevEle.querySelector('.sf__pcard-image .sf__image-box .spc__main-img img');
    let prevEleSubImg = prevEle.querySelector('.sf__pcard-image .sf__image-box .spc__hover-img img');
    let prevEleLink = prevEle.querySelector('.sf__pcard-image .sf__image-box .js-pcard-img-link');

    if (targetEle.tagName.toUpperCase() === 'LI'
      && targetEle.classList.contains('js-pcard-variants-item')) {
      if (targetEle.dataset.mainSrc) {
        prevEleMainImg.src = targetEle.dataset.mainSrc;
        prevEleMainImg.srcset = '';
        prevEleMainImg.srcset = `${targetEle.dataset.mainSrc}&width=165 165w,
        ${targetEle.dataset.mainSrc}&width=360 360w,
        ${targetEle.dataset.mainSrc}&width=533 533w,
        ${targetEle.dataset.mainSrc}&width=720 720w,
        ${targetEle.dataset.mainSrc}&width=940 940w,
        ${targetEle.dataset.mainSrc}&width=1066 1066w,
        ${targetEle.dataset.mainSrc}&width=1500 1500w,
        ${targetEle.dataset.mainSrc}&width=1780 1780w,
        ${targetEle.dataset.mainSrc}&width=2000 2000w`;
        prevEleLink.href = targetEle.dataset.link;
      }

      if (targetEle.dataset.secondSrc) {
        prevEleSubImg.src = targetEle.dataset.secondSrc;
        prevEleSubImg.srcset = '';
        prevEleSubImg.srcset = `${targetEle.dataset.secondSrc}&width=165 165w,
        ${targetEle.dataset.secondSrc}&width=360 360w,
        ${targetEle.dataset.secondSrc}&width=533 533w,
        ${targetEle.dataset.secondSrc}&width=720 720w,
        ${targetEle.dataset.secondSrc}&width=940 940w,
        ${targetEle.dataset.secondSrc}&width=1066 1066w,
        ${targetEle.dataset.secondSrc}&width=1500 1500w,
        ${targetEle.dataset.secondSrc}&width=1780 1780w,
        ${targetEle.dataset.secondSrc}&width=2000 2000w`;
      }
    }
  }, true)
})
